import * as ActionType from "./organizationUser.type";
import { apiInstance } from "../../util/api-new";

// Get Organization Users
export const getOrgUsers = (query) => async (dispatch) => {
  const queryParams = new URLSearchParams(query);

  apiInstance.get(`organization/members?${queryParams}`).then((res) => {
    dispatch({
      type: ActionType.GET_ORG_USERS,
      payload: {
        users: res.data.members,
        totalUsers: res.data.pagination.total,
      },
    });
  });
};

// Add Organization User
export const bulkAddOrgUser = (payload, currentTab) => async (dispatch) => {
  try {
    apiInstance.post("organization/members/bulk-add", payload).then((res) => {
      if (res.status) {
        const members = res.data?.orgMembers.filter((member) => {
          if (
            (currentTab === "Members" && member.role !== "caregiver") ||
            currentTab.toLowerCase().slice(0, -1) ===
              member.role.replace("org_", "").toLowerCase()
          ) {
            return true;
          }
          return false;
        });
        dispatch({
          type: ActionType.ADD_BULK_ORG_USER,
          payload: members,
        });
      }
    });
  } catch (error) {
    dispatch({
      type: ActionType.SET_ORG_USER_ERROR,
      payload: error.message,
    });
  }
};

// Add Organization User
export const addOrgUser = (userData, currentTab) => async (dispatch) => {
  try {
    apiInstance.post("organization/members/add", userData).then((res) => {
      if (res.status) {
        if (
          (currentTab === "Members" && userData.role !== "caregiver") ||
          currentTab.toLowerCase().slice(0, -1) ===
            userData.role.replace("org_", "").toLowerCase()
        ) {
          dispatch({
            type: ActionType.ADD_ORG_USER,
            payload: res.data?.orgMember,
          });
        }
      }
    });
  } catch (error) {
    dispatch({
      type: ActionType.SET_ORG_USER_ERROR,
      payload: error.message,
    });
  }
};

// Update Organization User
export const updateOrgUser = (memberId, updatedData) => async (dispatch) => {
  try {
    apiInstance
      .put(`organization/members/${memberId}`, updatedData)
      .then((res) => {
        if (res.status) {
          dispatch({
            type: ActionType.UPDATE_ORG_USER,
            payload: {
              userId: memberId,
              updatedData: res.data,
            },
          });
        }
      });
  } catch (error) {}
};

// Delete Organization User
export const deleteOrgUser = (userId) => async (dispatch) => {
  try {
    apiInstance.delete(`organization/members/${userId}`).then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.DELETE_ORG_USER,
          payload: userId,
        });
      }
    });
  } catch (error) {}
};

// Toggle Organization User Status
export const toggleOrgUserStatus = (userId) => async (dispatch) => {
  try {
    apiInstance
      .patch(`organization/members/${userId}/toggle-active`)
      .then((res) => {
        if (res) {
          dispatch({
            type: ActionType.TOGGLE_ORG_USER_STATUS,
            payload: res.data,
          });
        }
      });
  } catch (error) {
    dispatch({
      type: ActionType.SET_ORG_USER_ERROR,
      payload: error.message,
    });
  }
};

// Select Organization User
export const selectOrgUser = (user) => (dispatch) => {
  dispatch({
    type: ActionType.SELECT_ORG_USER,
    payload: user,
  });
};

// Clear Selected Organization User
export const clearSelectedOrgUser = () => (dispatch) => {
  dispatch({
    type: ActionType.CLEAR_SELECTED_ORG_USER,
  });
};

// Filter Organization Users
export const filterOrgUsers = (filters) => (dispatch) => {
  dispatch({
    type: ActionType.FILTER_ORG_USERS,
    payload: filters,
  });
};

// Search Organization Users
export const searchOrgUsers = (searchTerm) => (dispatch) => {
  dispatch({
    type: ActionType.SEARCH_ORG_USERS,
    payload: searchTerm,
  });
};

// Set Organization User Filter
export const setOrgUserFilter = (filterType, filterValue) => (dispatch) => {
  dispatch({
    type: ActionType.SET_ORG_USER_FILTER,
    payload: {
      filterType,
      filterValue,
    },
  });
};

// Department Actions
export const getOrgDepartments = () => async (dispatch) => {
  try {
    apiInstance.get("organization/departments").then((res) => {
      dispatch({
        type: ActionType.GET_ORG_DEPARTMENTS,
        payload: res.data,
      });
    });
  } catch (error) {}
};

export const addOrgDepartment = (payload) => async (dispatch) => {
  try {
    apiInstance.post("organization/departments", payload).then((res) => {
      dispatch({
        type: ActionType.ADD_ORG_DEPARTMENT,
        payload: res.data,
      });
    });
  } catch (error) {}
};

export const deleteOrgDepartment = (departmentId) => async (dispatch) => {
  try {
    apiInstance.delete(`organization/departments/${departmentId}`).then(() => {
      dispatch({
        type: ActionType.DELETE_ORG_DEPARTMENT,
        payload: departmentId,
      });
    });
  } catch (error) {}
};

export const updateOrgDepartment =
  (departmentId, updatedData) => async (dispatch) => {
    try {
      apiInstance
        .put(`organization/departments/${departmentId}`, updatedData)
        .then((res) => {
          dispatch({
            type: ActionType.UPDATE_ORG_DEPARTMENT,
            payload: {
              departmentId,
              updatedData: res.data,
            },
          });
        });
    } catch (error) {}
  };

// Role Actions
export const getOrgRoles = () => async (dispatch) => {
  const roles = [
    {
      id: 1,
      label: "Admin",
      value: "org_admin",
      permissions: ["all"],
      description: "Full access",
    },
    {
      id: 2,
      label: "Creator",
      value: "org_creator",
      permissions: ["manage_users", "view_reports"],
      description: "Department manager",
    },
    {
      id: 2,
      label: "Viewer",
      value: "org_viewer",
      permissions: ["view_courses"],
      description: "Regular member",
    },
    {
      id: 3,
      label: "Caregiver",
      value: "caregiver",
      permissions: ["view_courses"],
      description: "Caregiver",
    },
  ];

  dispatch({
    type: ActionType.GET_ORG_ROLES,
    payload: roles,
  });
};

export const addOrgRole = (roleData) => async (dispatch) => {
  try {
    dispatch({ type: ActionType.SET_ORG_USER_LOADING });

    setTimeout(() => {
      const newRole = {
        ...roleData,
        id: Math.random().toString(36).substring(2),
        createdAt: new Date().toISOString(),
      };

      dispatch({
        type: ActionType.ADD_ORG_ROLE,
        payload: newRole,
      });
    }, 500);
  } catch (error) {
    dispatch({
      type: ActionType.SET_ORG_USER_ERROR,
      payload: error.message,
    });
  }
};

export const deleteOrgRole = (roleId) => async (dispatch) => {
  try {
    dispatch({ type: ActionType.SET_ORG_USER_LOADING });

    setTimeout(() => {
      dispatch({
        type: ActionType.DELETE_ORG_ROLE,
        payload: roleId,
      });
    }, 500);
  } catch (error) {
    dispatch({
      type: ActionType.SET_ORG_USER_ERROR,
      payload: error.message,
    });
  }
};

export const updateOrgRole = (roleId, updatedData) => async (dispatch) => {
  try {
    dispatch({ type: ActionType.SET_ORG_USER_LOADING });

    setTimeout(() => {
      dispatch({
        type: ActionType.UPDATE_ORG_ROLE,
        payload: {
          roleId,
          updatedData,
        },
      });
    }, 500);
  } catch (error) {
    dispatch({
      type: ActionType.SET_ORG_USER_ERROR,
      payload: error.message,
    });
  }
};

// Clear Organization User Error
export const clearOrgUserError = () => (dispatch) => {
  dispatch({
    type: ActionType.CLEAR_ORG_USER_ERROR,
  });
};
